var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3936",
    "data-name": "Group 3936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M139.583,451.771A4.721,4.721,0,0,0,144.2,448h-9.236a4.721,4.721,0,0,0,4.618,3.771Zm0,0",
    transform: "translate(-126.864 -421.771)",
    fill: "#293462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M21.678,55.236h-.015a8.87,8.87,0,0,1-8.92-8.8,8.622,8.622,0,0,1,.853-3.728c-.28-.026-.565-.043-.853-.043a8.86,8.86,0,0,0-8.92,8.8v3.5A8.382,8.382,0,0,1,.779,61.422a2.181,2.181,0,0,0-.7,2.258A2.335,2.335,0,0,0,2.37,65.292H23.108a2.331,2.331,0,0,0,2.329-1.743,2.186,2.186,0,0,0-.761-2.152,8.321,8.321,0,0,1-3-6.161Zm0,0",
    transform: "translate(0 -40.154)",
    fill: "#293462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M268.581,6.285A6.285,6.285,0,1,1,262.3,0,6.284,6.284,0,0,1,268.581,6.285Zm0,0",
    transform: "translate(-240.583)",
    fill: "#e36f61"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIcon);
export default __webpack_public_path__ + "static/media/NotificationsIcon.849eadea42f27c30b13fdd35f9fa0881.svg";
export { ForwardRef as ReactComponent };